<template>
  <div>
    <v-flex xs12 class="mb-3">
      <h2 class="text-center mb-3">Nøkler</h2>
      <h4
        class="text-center"
        v-if="protocol.version.protocol_definition.protocol_type_id === 1"
      >Utleier har overlevert følgende typer nøkler til leietager:</h4>
      <h4
        class="text-center"
        v-if="protocol.version.protocol_definition.protocol_type_id === 2"
      >Leietager har tilbakelevert følgende nøkler:</h4>
    </v-flex>
    <v-alert v-if="protocol.related_protocol" :value="true" color="success" type="success">
      Skjemaet er ferdig utfylt med nøklene som ble levert ut ved innflyttingsprotokoll
    </v-alert>
    <v-flex xs12 class="mb-2 mt-3">
      <NumberInputTable
        objectTitle="Nøkkeltype"
        commentTitle="Kommentar/system nr"
        v-model="stepValues.keyList"
        @update-fields="updateFields"
      ></NumberInputTable>
    </v-flex>
    <v-flex xs12 v-if="config.info">
      <i v-html="config.info" />
    </v-flex>
    <v-divider></v-divider>
    <v-flex xs12 class="mb-3">
      <v-textarea box label="Andre kommentarer" v-model="stepValues.comment" @input="updateFields"></v-textarea>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import NumberInputTable from "../form/NumberInputTable.vue";
import KEYTYPES from "../../models/keyTypes";
import step from "../../mixins/step";
export default {
  mixins: [step],
  components: { NumberInputTable},
  mounted: function() {
    if(this.protocol.related_protocol && this.stepValues) {
      if(this.stepValues.loadedFromRelated == null || this.stepValues.loadedFromRelated == undefined) {
        if(this.protocol.related_protocol.steps.keys.saved_values.keyList) {
          this.stepValues.loadedFromRelated = true
          let keyList = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.keys.saved_values.keyList))
          this.stepValues.keyList = keyList
        }
      }
    }
    if(this.stepValues.keyList) {
      if(this.stepValues.keyList.length === 0) {
        this.stepValues.keyList = KEYTYPES
      }
    }
  }
}
</script>
